import React, { useContext } from 'react'

import { Switch, Route, withRouter } from 'react-router-dom'
import { Routes } from '../routes'
import ProfilePageView from '../Views/student/ProfilePageView'
import { GlobalContext } from '../Providers/GlobalProvider'
import StudentProvider from '../Providers/Student/StudentProvider'
import ChangeLogView from '../Views/shared/ChangeLogView'
import SectorModal from '../Providers/Forms/SectorModal'
import InternshipsView from '../Views/student/InternshipsView/InternshipsView'

const StudentRouter = () => {
  const { currentDate } = useContext(GlobalContext)

  return (
    <Switch>
      <StudentProvider>
        <Route path={Routes.INTERNSHIPS}>
          <div className='inner-spacing'>
            <SectorModal readOnly>
              <InternshipsView currentDate={currentDate} />
            </SectorModal>
          </div>
        </Route>
        <Route path={Routes.PROFILE_PAGE}>
          <ProfilePageView />
        </Route>
        <Route path={Routes.CHANGELOG}>
          <ChangeLogView />
        </Route>
      </StudentProvider>
    </Switch>
  )
}

export default withRouter(StudentRouter)
